import { useCallback } from 'react';

import {
  Active,
  DataRef,
  DndContext,
  DndContextProps,
  KeyboardSensor,
  Over,
  PointerSensor,
  pointerWithin,
  TouchSensor,
  useSensor,
  useSensors,
} from '@dnd-kit/core';
import { restrictToWindowEdges } from '@dnd-kit/modifiers';

export interface CustomActive extends Active {
  data: DataRef<{
    type: string;
  }>;
}

export interface CustomOver extends Over {
  data: DataRef<{
    accepts: string;
  }>;
}

export interface CustomDragEvent extends DragEvent {
  active: CustomActive;
  over: CustomOver | null;
}

export interface DragEndEvent extends CustomDragEvent {}

export interface DraggableContextProps extends DndContextProps {
  children?: React.ReactNode;
}

export const DraggableContext: React.FC<DraggableContextProps> = ({ children }) => {
  const isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
  const defaultSensors = useSensors(
    useSensor(KeyboardSensor), // Default option
    useSensor(PointerSensor) // Default option
  );
  const touchSensor = useSensors(
    useSensor(TouchSensor, {
      activationConstraint: {
        distance: 50, // pixels by which the touch input needs to be moved before a drag start event is emitted.
        delay: 100, // milliseconds that a draggable item needs to be held by the touch input before a drag start event is emitted.
        // pixels of motion that is tolerated before the drag operation is aborted.
        // the operation will only be aborted if the finger is moved by more than 5 pixels during the delay.
        // This is useful for scrolling on touch devices.
        tolerance: 5,
      },
    })
  );
  const sensors = !isTouchDevice ? defaultSensors : touchSensor;

  const handleDragEnd = useCallback<PickProp<DndContextProps, 'onDragEnd'>>((event) => {
    const { active, over } = event as any as CustomDragEvent;

    const accepts = over && over.data.current?.accepts;
    const type = active?.data?.current?.type;
    if (type && accepts && accepts.includes(type)) {
      // console.log('yeah');
    }
  }, []);

  const handleDragOver = useCallback<PickProp<DndContextProps, 'onDragOver'>>((event) => {
    const { active, over } = event as any as CustomDragEvent;

    const accepts = over && over.data.current?.accepts;
    const type = active?.data?.current?.type;
    if (type && accepts && accepts.includes(type)) {
      // console.log('over yeah');
    }
  }, []);

  return (
    <DndContext
      collisionDetection={pointerWithin}
      modifiers={[restrictToWindowEdges]}
      sensors={sensors}
      onDragEnd={handleDragEnd}
      onDragOver={handleDragOver}
    >
      {children}
    </DndContext>
  );
};
